import React from "react";
import "./styles.scss";

class Frequency extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            title: this.props.title,
        };
    }

    componentDidMount() {
        this.setState({isLoading: true});

        const fetchData = () => {
            fetch("https://gigastorageinterface.ew.r.appspot.com/frequency/NL")
                .then((res) => res.json())
                .then(
                    (result) => {
                        this.setState({
                            isLoading: false,
                            frequency: parseFloat(result[0].frequency)
                        });
                    }
                );
        };

        fetchData();
        setTimeout(() => {
            fetchData();
        }, 1000);
    }

  render() {
      if (this.state.isLoading) {
          return <div>Fetching data from API</div>
      }

      return (
        <div className="el-frequency">
            <h4>{this.state.title}</h4>
            <span className="js-data_frequency">
                {this.state.frequency}
            <span>hz</span>
            </span>
        </div>
      );
  }
}

export default Frequency;
